import { useLocation, useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { Arrange, Box, Link } from '@flodesk/grain';

const styles = {
  activeLink: css`
    font-weight: var(--grn-weight-medium);
    color: var(--grn-color-content);
  `,
  inactiveLink: css`
    font-weight: var(--grn-weight-normal);
  `,
};

const NAV_ITEMS = [
  { label: 'Data and privacy', path: '/settings/data-and-privacy' },
  { label: 'Opt-in setup', path: '/settings/opt-in-setup' },
  { label: 'Subscribers', path: '/subscribers' },
  { label: 'Analytics messages', path: '/analytics/messages' },
];

export function FloatingNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box position="fixed" bottom="l" left="0" right="0" zIndex="10">
      <Arrange columns="1fr" justifyItems="center">
        <Box
          padding="s2"
          backgroundColor="background"
          borderColor="border"
          borderWidth={1}
          borderSide="all"
          radius="l"
          shadow="l"
        >
          <Arrange columns={`repeat(${NAV_ITEMS.length}, auto)`} gap="m">
            {NAV_ITEMS.map(item => {
              const isCurrent = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  href={item.path}
                  variant="subtle"
                  onClick={event => {
                    event.preventDefault();
                    navigate(item.path);
                  }}
                  css={isCurrent ? styles.activeLink : styles.inactiveLink}
                  aria-current={isCurrent ? 'page' : undefined}
                >
                  {item.label}
                </Link>
              );
            })}
          </Arrange>
        </Box>
      </Arrange>
    </Box>
  );
}
